module.exports = __webpack_public_path__ + "img/orange_128.2efb1b77.png";